import { css } from "lit"

export const footerGroupsStyles = css`
  /* Footer groups */
  .footer-groups {
    padding: 1.25rem;
  }

  .footer-groups-container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-group {
    margin: 1.5rem 0;
  }

  .footer-group-title {
    font-size: 1.125rem;
    font-family: Georgia, serif;
    color: #1f2937;
    margin-bottom: 1.25rem;
  }

  .footer-group-links {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .footer-group-link {
    font-size: 0.875rem;
    color: #333333;
  }

  .footer-group-link-separator {
    font-size: 0.6rem;
    line-height: 1rem;
    color: #949494;
    margin-bottom: 0.25rem;
    font-family:
      Avenir LT W01_65 Heavy1475544,
      Avenir,
      sans-serif;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 600;
  }

  .footer-group-link-all {
    cursor: pointer;
    letter-spacing: 0.1em;
    color: #647a1c;
    font-size: 0.7rem;
    font-family:
      Avenir LT W01_85 Heavy1475544,
      Avenir,
      sans-serif;
    text-transform: uppercase;
    font-weight: 600;
  }

  .footer-group-link-all:hover {
    color: #647a1c;
  }

  .footer-group-link:hover {
    color: #647a1c;
  }

  @media (min-width: 768px) {
    .footer-groups-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1024px) {
    .footer-groups-container {
      justify-content: space-between;
      grid-template-columns: repeat(3, 1fr);
      gap: 10rem;
    }
  }
`
